package dev.terrakok.mapitan.domain.geojson

import dev.terrakok.mapitan.domain.LineStyle
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.jsonPrimitive
import org.maplibre.spatialk.geojson.Feature
import org.maplibre.spatialk.geojson.Geometry

object MapKeys {
    const val PIN_LAYER_ID = "all-pins"
    const val SELECTION_LAYER_ID = "selection-frame"
    const val LABEL_LAYER_ID = "all-labels"
    const val LABEL_SELECTION_LAYER_ID = "label-selection-frame"
    const val TRACK_LINE_LAYER_ID = "all-track-lines"
    const val TRACK_POINT_LAYER_ID = "all-track-points"
    const val TRACK_SELECTION_LAYER_ID = "track-selection"
    const val AREA_FILL_LAYER_ID = "all-area-fills"
    const val AREA_LINE_LAYER_ID = "all-area-lines"
    const val AREA_POINT_LAYER_ID = "all-area-points"
    const val AREA_SELECTION_LAYER_ID = "area-selection"
    const val DRAFT_CURSOR_LAYER_ID = "draft-cursor-line"
    const val DRAFT_TRACK_ID = "draft-track"
    const val DRAFT_AREA_ID = "draft-area"

    const val MAPITAN_ID_PROPERTY = "mt-id"
    const val COLOR_PROPERTY = "color"
    const val THICKNESS_PROPERTY = "thickness"
    const val LINE_STYLE_PROPERTY = "lineStyle"
    const val POINT_PARENT_ID_PROPERTY = "mt-track-point-parent-id"

    const val TEXT_PROPERTY = "text"

    fun trackLineLayerId(style: LineStyle) = "$TRACK_LINE_LAYER_ID-${style.name}"
    val TRACK_LINE_LAYER_IDS: Set<String> = LineStyle.entries.map(::trackLineLayerId).toSet()

    fun areaLineLayerId(style: LineStyle) = "$AREA_LINE_LAYER_ID-${style.name}"
    val AREA_LINE_LAYER_IDS: Set<String> = LineStyle.entries.map(::areaLineLayerId).toSet()

}

fun List<Feature<Geometry, JsonObject?>>.findDocumentObjectIds(): List<String> = mapNotNull {
    it.properties?.get(MapKeys.MAPITAN_ID_PROPERTY)?.jsonPrimitive?.content
}